import { atom } from 'recoil';
import defaultProjectsTotal from 'ProjectManager/Project/List/recoil/totalCount/defaultProjectsTotal';

const projectsTotalCountAtom = atom({
    key: 'projectManagement_projectsListTotalCount',
    default: defaultProjectsTotal,
});

export default projectsTotalCountAtom;
